// GENERATED FILE — DO NOT EDIT.
// Source: hsos-shared/src/analytics/ — edit there, then run:
//   node scripts/sync-shared-modules.mjs
// Target: hsos-web vendored @hsos/shared

/**
 * PostHog group analytics — tenant identity.
 *
 * Helm is multi-tenant: every product signal belongs to an organization, and
 * almost every founder question ("which tenants are healthy?", "does activation
 * predict retention?") is a per-org question. PostHog answers those only when
 * events are attached to a group, so `organization` is the platform's single
 * group type and every tenant-scoped event carries it.
 *
 * Group type indexes are assigned by PostHog on first use and are immutable —
 * `organization` is index 0 in the Helm project. Do not add a second group type
 * without a migration plan; PostHog allows a maximum of five per project.
 */

/** The one PostHog group type Helm uses. Value must match the PostHog project. */
export const ORGANIZATION_GROUP_TYPE = "organization" as const;

export type AnalyticsGroupType = typeof ORGANIZATION_GROUP_TYPE;

/**
 * Group properties kept on the organization in PostHog.
 *
 * These are the dimensions the founder console segments tenants by, so they are
 * written on every meaningful org state change rather than only at creation.
 */
export type OrganizationGroupProperties = {
  name?: string;
  slug?: string;
  plan?: string;
  /** `trialing` | `active` | `past_due` | `canceled` | `pilot` */
  subscription_status?: string;
  /**
   * The trade the shop leads with — `organizations.industry`.
   *
   * Stays the primary so every existing insight keeps segmenting the way it
   * always has; `trades` is the additive dimension for shops working in more
   * than one.
   */
  trade?: string;
  /** Every trade the shop works in, primary first — `organizations.trades`. */
  trades?: readonly string[];
  /** Seat count — headcount with console access. */
  seats?: number;
  /** ISO date the org was created; drives cohort and retention analysis. */
  created_at?: string;
  /** ISO date the org first sent or answered a real customer message. */
  activated_at?: string;
  /** `sandbox` | `pilot` | `production` — where the org sits in its lifecycle. */
  lifecycle_stage?: string;
  /** Current AI autonomy level (0-3). */
  autonomy_level?: number;
  /** True once A2P/carrier registration clears and production SMS is allowed. */
  sms_enabled?: boolean;
  /** Monthly recurring revenue in whole dollars. */
  mrr_usd?: number;
};

/** Build the `$groups` payload for a tenant-scoped capture. */
export function organizationGroup(
  organizationId: string,
): Record<AnalyticsGroupType, string> {
  return { [ORGANIZATION_GROUP_TYPE]: organizationId };
}
